import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { activityDetailStore } from '@client/store/activityDetailStore';
import { newListData } from '../table/hooks/useLapData';

export default function useDrawChart({ isOverview, isIndexRect, drawChart }) {
  const activityDetailStoreRef = activityDetailStore();
  const chartData = computed(() => {
    if (isIndexRect) {
      return newListData.value;
    }

    if (isOverview) {
      return activityDetailStoreRef.polylineData;
    }
    return activityDetailStoreRef.frameSelection?.data;
  });
  const pauseList = computed(() => activityDetailStoreRef.pauseList);

  const drawChartTimeout = ref(0);
  onBeforeUnmount(() => {
    if (drawChartTimeout.value) {
      clearTimeout(drawChartTimeout.value);
    }
  });
  const tryToDrawChart = () => {
    if (drawChartTimeout.value) {
      clearTimeout(drawChartTimeout.value);
    }
    nextTick(() => {
      drawChartTimeout.value = setTimeout(drawChart, 100);
    });
  };

  watch(chartData, () => {
    if (!isOverview) {
      tryToDrawChart();
    }
  });

  onMounted(() => {
    tryToDrawChart();
  });

  return {
    tryToDrawChart,
    chartData,
    pauseList
  };
}
